import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://rywrbkrpxjljnplshvsn.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJ5d3Jia3JweGpsam5wbHNodnNuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzY3NzIxNjYsImV4cCI6MjA5MjM0ODE2Nn0.sfGXfTYxfc6A1XEH5krT7bFVZ-5aoQvSv8Paxjo5_V0';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export const BLOOD_GROUPS = ['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'];

// Simple ward numbers — no fake area descriptions
export const WARDS = [
  'വാർഡ് 1',
  'വാർഡ് 2',
  'വാർഡ് 3',
  'വാർഡ് 4',
  'വാർഡ് 5',
  'വാർഡ് 6',
  'വാർഡ് 7',
  'വാർഡ് 8',
  'വാർഡ് 9',
  'വാർഡ് 10',
  'വാർഡ് 11',
  'വാർഡ് 12',
  'വാർഡ് 13',
  'വാർഡ് 14',
];

// Points awarded per action
export const POINTS = {
  REGISTER: 10,
  DONATE: 50,
  REQUEST_FULFILLED: 20,
};

// Alias for POINTS — used by Register.js and other pages
export const REWARD_POINTS = POINTS;

// Tier thresholds
export const TIERS = [
  { name: 'ഹീറോ', nameEn: 'Hero', min: 200, icon: '🥇', color: '#FFD700' },
  { name: 'ചാമ്പ്യൻ', nameEn: 'Champion', min: 100, icon: '🥈', color: '#C0C0C0' },
  { name: 'സ്റ്റാർ', nameEn: 'Star', min: 50, icon: '⭐', color: '#CD7F32' },
  { name: 'അംഗം', nameEn: 'Member', min: 0, icon: '🩸', color: '#d90429' },
];

export function getTier(points) {
  return TIERS.find(t => points >= t.min) || TIERS[TIERS.length - 1];
}

// Alias for getTier — kept for backwards compatibility
export const getDonorTier = getTier;

// Minimum days between donations (WHO / Indian blood bank standard)
export const DONATION_COOLDOWN_DAYS = 56;

// Returns true if the donor is eligible to donate again
export function isDonorEligible(lastDonated) {
  if (!lastDonated) return true;
  const last = new Date(lastDonated);
  const eligibleFrom = new Date(last);
  eligibleFrom.setDate(eligibleFrom.getDate() + DONATION_COOLDOWN_DAYS);
  return new Date() >= eligibleFrom;
}

// Returns how many days remain until eligible (0 if already eligible)
export function daysUntilEligible(lastDonated) {
  if (!lastDonated) return 0;
  const last = new Date(lastDonated);
  const eligibleFrom = new Date(last);
  eligibleFrom.setDate(eligibleFrom.getDate() + DONATION_COOLDOWN_DAYS);
  const diff = Math.ceil((eligibleFrom - new Date()) / (1000 * 60 * 60 * 24));
  return diff > 0 ? diff : 0;
}

// A donor is truly available only if both:
// 1. is_available flag is true in DB
// 2. they are past the 56-day cooldown
export function isDonorAvailable(donor) {
  if (!donor.is_available) return false;
  return isDonorEligible(donor.last_donated);
}
